import { lazy } from "react";
import type { IRoute } from "./types";

// Dashboard
const Carousel = lazy(() => import("../pages/dashboard/home/carousel"));
const OurService = lazy(() => import("../pages/dashboard/home/ourservice"));
const PartnerOrganization = lazy(
  () => import("../pages/dashboard/home/partner_org")
);
const FAQ = lazy(() => import("../pages/dashboard/home/faq"));

// About
const Introduction = lazy(() => import("@/pages/dashboard/about/intro"));
const Introduction2 = lazy(() => import("@/pages/dashboard/about/intro2"));
const Team = lazy(() => import("@/pages/dashboard/about/team"));
const Features = lazy(() => import("@/pages/dashboard/about/feature"));

// Product
const Product = lazy(() => import("@/pages/dashboard/product"));

// News
const NewsComponent = lazy(() => import("../pages/dashboard/news"));

// WorkPlace
const WorkPlace = lazy(() => import("@/pages/dashboard/workplace/list"));
const Resume = lazy(() => import("@/pages/dashboard/workplace/resume"));

// Techbology Solution
const SolutionOverview = lazy(
  () => import("../pages/dashboard/solution/overview")
);
const SolutionFeatures = lazy(
  () => import("../pages/dashboard/solution/features")
);
const SolutionExtras = lazy(() => import("../pages/dashboard/solution/extras"));

// Contact
const ContactPage = lazy(() => import("../pages/dashboard/contact/page"));
const ReceivedRequest = lazy(
  () => import("../pages/dashboard/contact/request")
);

// Settings
const Staffs = lazy(() => import("../pages/dashboard/settings/staff"));
const Menu = lazy(() => import("../pages/dashboard/settings/menu"));
const Roles = lazy(() => import("../pages/dashboard/settings/role"));
const ActionLog = lazy(() => import("../pages/dashboard/settings/action_log"));

const NotFound = lazy(() => import("../pages/exceptions/NotFound"));

const dashboardRoutes: IRoute[] = [
  // Dashboard Home
  {
    key: "/dashboard/home/carousel",
    path: "/dashboard/home/carousel",
    component: <Carousel />,
  },
  {
    key: "/dashboard/home/ourservice",
    path: "/dashboard/home/ourservice",
    component: <OurService />,
  },
  {
    key: "/dashboard/home/partners",
    path: "/dashboard/home/partners",
    component: <PartnerOrganization />,
  },
  {
    key: "/dashboard/home/faq",
    path: "/dashboard/home/faq",
    component: <FAQ />,
  },

  // Dashboard About
  {
    key: "/dashboard/about/intro",
    path: "/dashboard/about/intro",
    component: <Introduction />,
  },
  {
    key: "/dashboard/about/feature",
    path: "/dashboard/about/feature",
    component: <Features />,
  },
  {
    key: "/dashboard/about/team",
    path: "/dashboard/about/team",
    component: <Team />,
  },
  {
    key: "/dashboard/about/intro2",
    path: "/dashboard/about/intro2",
    component: <Introduction2 />,
  },
  // Dashboard Product
  {
    key: "/dashboard/product",
    path: "/dashboard/product",
    component: <Product />,
  },

  // Dashboard News
  {
    key: "/dashboard/news",
    path: "/dashboard/news",
    component: <NewsComponent />,
  },

  // Techbology Solution

  {
    key: "/dashboard/tech/intro",
    path: "/dashboard/tech/intro",
    component: <SolutionOverview />,
  },
  {
    key: "/dashboard/tech/highlight",
    path: "/dashboard/tech/highlight",
    component: <SolutionFeatures />,
  },

  {
    key: "/dashboard/tech/extras",
    path: "/dashboard/tech/extras",
    component: <SolutionExtras />,
  },
  // Contact

  {
    key: "/dashboard/contact/page",
    path: "/dashboard/contact/page",
    component: <ContactPage />,
  },
  {
    key: "/dashboard/contact/request",
    path: "/dashboard/contact/request",
    component: <ReceivedRequest />,
  },

  // Dashboard Workplace
  {
    key: "/dashboard/workplace/list",
    path: "/dashboard/workplace/list",
    component: <WorkPlace />,
  },
  {
    key: "/dashboard/workplace/resume",
    path: "/dashboard/workplace/resume",
    component: <Resume />,
  },
  // Settings
  {
    key: "/dashboard/settings/action_log",
    path: "/dashboard/settings/action_log",
    component: <ActionLog />,
  },
  {
    key: "/dashboard/settings/staff",
    path: "/dashboard/settings/staff",
    component: <Staffs />,
  },

  {
    key: "/dashboard/settings/menu",
    path: "/dashboard/settings/menu",
    component: <Menu />,
  },

  {
    key: "/dashboard/settings/role",
    path: "/dashboard/settings/role",
    component: <Roles />,
  },

  {
    key: "not_found",
    path: "*",
    component: <NotFound />,
  },
];
export default dashboardRoutes;
